import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "bottom" }
const _hoisted_4 = {
  href: "mailto:timothe.natte@etu.umontpellier.fr",
  class: "mdi mdi-gmail"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToHome && _ctx.navigateToHome(...args))),
        class: "mdi mdi-home"
      }, null, 512), [
        [_directive_tooltip, 'Accueil']
      ]),
      _withDirectives(_createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToAbout && _ctx.navigateToAbout(...args))),
        class: "mdi mdi-information"
      }, null, 512), [
        [_directive_tooltip, 'À Propos de moi']
      ]),
      _withDirectives(_createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToCompetence && _ctx.navigateToCompetence(...args))),
        class: "mdi mdi-account-badge-outline"
      }, null, 512), [
        [_directive_tooltip, 'Compétences']
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("a", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navigateToCV && _ctx.navigateToCV(...args))),
        class: "mdi mdi-file-document-outline"
      }, null, 512), [
        [_directive_tooltip, 'Mon CV']
      ]),
      _withDirectives(_createElementVNode("a", _hoisted_4, null, 512), [
        [_directive_tooltip, 'Mail']
      ])
    ])
  ]))
}